module.exports = new __parcel__URL__("tiktok.6e60b867.png").toString();